import React, { useState } from "react";
import { ImageOff } from "lucide-react";
import { Seo } from "../components/Seo";
import { Reveal, SectionHeader } from "../components/site/Reveal";
import { GALLERY_CATEGORIES } from "../lib/content";

const SLOTS = [
  { id: 1, cat: "exterior" }, { id: 2, cat: "interior" }, { id: 3, cat: "correction" },
  { id: 4, cat: "ceramic" }, { id: 5, cat: "performance" }, { id: 6, cat: "exterior" },
  { id: 7, cat: "ceramic" }, { id: 8, cat: "interior" }, { id: 9, cat: "correction" },
];

export default function Gallery() {
  const [cat, setCat] = useState("all");
  const visible = SLOTS.filter((s) => cat === "all" || s.cat === cat);
  return (
    <>
      <Seo title="Gallery" description="SPECA Detailing portfolio — exterior, interior, paint correction and ceramic coating work on luxury and performance vehicles in Melbourne." path="/gallery" />
      <section className="pt-32 pb-10 md:pt-40">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <SectionHeader overline="Portfolio" title="Our work." description="Real SPECA Detailing photographs across every service. Images are being added — follow us on Instagram for the latest." />
        </div>
      </section>

      <section className="pb-20">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="flex flex-wrap gap-2 mb-8">
            {GALLERY_CATEGORIES.map((c) => (
              <button key={c.id} onClick={() => setCat(c.id)} data-testid={`gallery-cat-${c.id}`}
                className={`px-4 py-2 text-xs uppercase tracking-widest font-bold transition-colors ${cat === c.id ? "bg-silver text-black" : "border border-white/15 text-gray-400 hover:text-white hover:border-white"}`}>
                {c.label}
              </button>
            ))}
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
            {visible.map((s, i) => (
              <Reveal key={s.id} delay={(i % 3) * 0.06}>
                <div data-testid={`gallery-item-${s.id}`} className="relative aspect-square overflow-hidden matte grain flex items-center justify-center">
                  <div className="absolute inset-0 bg-[radial-gradient(ellipse_50%_50%_at_50%_50%,rgba(184,184,184,0.08),transparent_65%)]" />
                  <div className="relative z-10 text-center px-4">
                    <ImageOff className="text-white/20 mx-auto mb-2" size={28} />
                    <p className="text-gray-500 text-xs">{GALLERY_CATEGORIES.find((c) => c.id === s.cat)?.label}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
          {visible.length === 0 && <p className="text-center text-gray-500 py-20">No items in this category yet.</p>}
        </div>
      </section>
    </>
  );
}
